import ConfirmDialog from "components/ConfirmDialog";

type DeleteEntityProps = {
  dialogTitleKey: string;
  contentKey?: string;
  rawContent?: string;
  confirmLabel?: string;
  open: boolean;
  onCancel: () => void;
  handleDelete: () => void;
};

const DeleteEntityDialog = ({
  dialogTitleKey,
  contentKey,
  rawContent,
  confirmLabel = "deleteButton",
  open,
  onCancel,
  handleDelete,
}: DeleteEntityProps) => {
  return (
    <ConfirmDialog
      dialogTitleKey={dialogTitleKey}
      contentKey={contentKey}
      rawContent={rawContent}
      open={open}
      onCancel={onCancel}
      handleConfirm={handleDelete}
      confirmLabel={confirmLabel}
    />
  );
};

export default DeleteEntityDialog;
